import gsap from "gsap";

// Exposed so World.triggerFinale() can start EpisodeSlider's matching
// zoom-out with the exact same duration, synchronized to open().
export const OPEN_DURATION = 0.9;

// Two opaque black DOM panels (top half / bottom half) covering the full
// viewport, then parting like a curtain — the transition from the baked
// timeline's last frame into the finale's episode slider.
//
// Built as plain DOM (not WebGL scene planes, an earlier approach) so it
// shares one stacking context with EpisodeSlider's own DOM overlay and
// ordinary z-index just works: the curtain sits above the slider the whole
// time it exists, and once it's disposed there's nothing left to
// accidentally sit on top of the slider afterward. A WebGL-plane curtain
// (rendered into the canvas) can't achieve this — the canvas and the
// slider's DOM are two separate stacking contexts, so z-index can only put
// one of them entirely above the other; the curtain would have needed to
// live "inside" the canvas's content in front of the slider's DOM during
// the transition, then get out from in front of it after, which isn't
// something z-index alone can express across a canvas/DOM boundary.
export default class EndCurtain {
  constructor() {
    this.visible = false;
    this.buildDom();
  }

  buildDom() {
    const topPanel = document.createElement("div");
    topPanel.className = "end-curtain end-curtain-top";

    const bottomPanel = document.createElement("div");
    bottomPanel.className = "end-curtain end-curtain-bottom";

    document.body.append(topPanel, bottomPanel);

    this.topPanel = topPanel;
    this.bottomPanel = bottomPanel;
  }

  // Snaps both panels to fully covering the viewport, instantly — no tween
  // needed since this is meant to already look "closed" the moment it
  // appears, not animate into that state.
  close() {
    gsap.set(this.topPanel, { yPercent: 0 });
    gsap.set(this.bottomPanel, { yPercent: 0 });
    this.visible = true;
  }

  // Parts the curtain: the top panel slides fully off the top edge, the
  // bottom panel fully off the bottom edge (each translates by its own
  // full height), so the opening motion reads as parting from the centre
  // outward. onComplete fires once, after which the curtain is disposed.
  open(onComplete) {
    const tl = gsap.timeline({
      onComplete: () => {
        this.dispose();
        onComplete?.();
      },
    });

    tl.to(this.topPanel, { yPercent: -100, duration: OPEN_DURATION, ease: "power3.inOut" }, 0);
    tl.to(this.bottomPanel, { yPercent: 100, duration: OPEN_DURATION, ease: "power3.inOut" }, 0);
  }

  dispose() {
    this.visible = false;
    this.topPanel.remove();
    this.bottomPanel.remove();
  }

  update() {
    // Purely CSS-transform/gsap driven — nothing needed per-tick. Present
    // for symmetry with World's other systems and Debug's per-system
    // timing brackets.
  }
}
